// Shared ordering helpers for the news_page array in staticVars.js.
// Used by the News page grid and by the "latest news" sections on the home pages.

// published_date in news_page is hand-entered and inconsistent: "July 28,2026",
// "May 27, 2025", "April 18, 2022 " (trailing space), plus abbreviations and
// mixed case ("Jul", "JUL", "MAR", "AUGUST") and typos ("Janurary", "Octuber").
// The first three letters identify all twelve months uniquely and survive every
// one of those variants, so prefix matching absorbs the typos without a special case.
const MONTH_INDEX = {
    jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
    jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11
}

// Parsed timestamps are memoised: the callers re-run on every filter click and
// every Load More, and this also keeps the unparseable-date warning to once per value.
const dateCache = new Map()

// Returns a UTC timestamp, or null when the value cannot be understood.
export function parsePublishedDate(value){
    if(dateCache.has(value)) return dateCache.get(value)

    let result = null
    if(typeof value === 'string'){
        const month = value.match(/[A-Za-z]+/)
        const numbers = value.match(/\d+/g)
        if(month && numbers && numbers.length >= 2){
            const monthIndex = MONTH_INDEX[month[0].slice(0, 3).toLowerCase()]
            // A 4-digit token is the year wherever it sits; otherwise assume "<day> <year>".
            const yearToken = numbers.find(n => n.length === 4)
            const dayToken = numbers.find(n => n !== yearToken)
            if(monthIndex !== undefined && yearToken){
                const stamp = Date.UTC(Number(yearToken), monthIndex, Number(dayToken || 1))
                if(!isNaN(stamp)) result = stamp
            }
        }
    }

    if(result === null){
        console.warn('[News] Unparseable published_date, sorting it oldest:', value)
    }
    dateCache.set(value, result)
    return result
}

// Newest first. Unparseable dates sink to the bottom rather than breaking the sort.
// Returns a new array - news_page is shared module state and must not be reordered.
export function sortByPublishedDateDesc(list){
    if(!Array.isArray(list)) return list
    return list.slice().sort((a, b) => {
        const left = parsePublishedDate(a && a.published_date)
        const right = parsePublishedDate(b && b.published_date)
        if(left === right) return 0
        if(left === null) return 1
        if(right === null) return -1
        return right - left
    })
}
